// extracted by mini-css-extract-plugin
export var chip = "_5t-9";
export var chipLabel = "_5t-a";
export var close = "_5t-7";
export var closeIcon = "_5t-8";
export var error = "_5t-6";
export var infoTooltip = "_5t-2";
export var innerContainer = "_5t-1";
export var input = "_5t-b";
export var medium = "_5t-5";
export var outerContainer = "_5t-0";
export var small = "_5t-4";
export var xSmall = "_5t-3";